import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SiteWrapper from '../components/sitewrapper'
import Heading from '../components/heading'
import Layout from '../components/layout'
import Intro from '../components/intro'
import Row, { Slot } from '../components/row'
import Button from '../components/button'
import ProgressBar from '../components/progress-bar'
import Score from '../components/score'
import AuditTable from '../components/audit-table'
import Bubble from '../components/bubble'
import styles from '../component-styles/audit.module.scss'
import { subscribeToAudit } from '../store/actions'
import RequestAnExpert from '../components/request-an-expert'

export default function Audit(): React.ReactElement {
  const dispatch = useDispatch()
  const { audit, user } = useSelector((s: any): any => s)
  const auditData = audit
  const [raeActive, setRaeActive] = useState(false)
  const [run, setRun] = useState(false)
  const [helpMeWith, setHelpMeWith] = useState('')
  const failedTests = auditData.tests.filter((a: any): boolean => !a.passed)
  const passedTests = auditData.tests.filter((a: any): boolean => a.passed)

  useEffect((): void => {
    if (!run && auditData.tests.length <= 0 && user.details !== null) {
      setRun(true)
      dispatch(subscribeToAudit(user.details.uid, user.runningDebug))
    }
    // eslint-disable-next-line
  }, [auditData.tests, user.details])

  return (
    <SiteWrapper>
      <Layout>
        <Intro title="Google Analytics audit">
          <p>
            Fix issues in your Google Analytics data which may affect your data
            quality and accuracy.
          </p>
        </Intro>
        <Row>
          <Slot width={180}>
            <Button
              disabled={auditData.inProgress}
              onClick={(): ReduxAction =>
                dispatch(subscribeToAudit(user.details.uid, user.runningDebug))
              }
            >
              Run Audit
            </Button>
          </Slot>
          <Slot padding="0 20px">
            <ProgressBar percentage={audit.percentage} />
          </Slot>
          <Slot width={180} />
        </Row>
        <Score
          percentage={
            (passedTests.length / auditData.totalTestsToRun) * 100 || 0
          }
          failed={failedTests.length}
          passed={passedTests.length}
          toggleActive={(): void => setRaeActive(!raeActive)}
        />
        <AuditTable
          type="failed"
          tableData={audit.percentage === 100 ? failedTests : []}
          toggleActive={(title: string): void => {
            if (title) {
              setHelpMeWith(title)
            }
            setRaeActive(!raeActive)
          }}
        />
        <AuditTable
          type="passed"
          tableData={audit.percentage === 100 ? passedTests : []}
          toggleActive={(title: string): void => {
            if (title) {
              setHelpMeWith(title)
            }
            setRaeActive(!raeActive)
          }}
        />
        <Bubble direction="none" className={styles.prize}>
          <Heading type={4} align="center">
            Can you think of a new Google Analytics audit test, or a better
            solution?
          </Heading>
          <p>
            If so, email{' '}
            <a href="mailto:support@uplifter.ai" title="email">
              support@uplifter.ai
            </a>{' '}
            for a chance to win a prize.
          </p>
        </Bubble>
        <RequestAnExpert
          active={raeActive}
          toggleActive={(): void => setRaeActive(!raeActive)}
          helpMeWith={helpMeWith}
        />
      </Layout>
    </SiteWrapper>
  )
}
